import { Line } from "react-chartjs-2";
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { useEffect, useState } from "react";
import { getDerivacionesPorAnio } from "./serviceOrion";
import { BACKGROUND_COLOR_PLUGIN } from "./../shared/utils";
import TituloYDescarga from "../shared/components/TituloYDescarga";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip
);

const DerivacionesOrionTiempo = () => {
  const [dataSet, setDataSet] = useState(null);

  const CHART_ID = "derivaciones_orion_tiempo";
  const CHART_TITLE = "Cantidad de derivaciones por año";

  useEffect(() => {
    async function fetchData() {
      setDataSet(await getDerivacionesPorAnio());
    }
    fetchData();
  }, []);

  const options = {
    plugins: {
      legend: true,
    },
  };

  return (
    <>
      <TituloYDescarga
        titulo={CHART_TITLE}
        idsCharts={[CHART_ID]}
        chartsNames={[CHART_ID]}
      />
      {dataSet ? (
        <Line
          id={CHART_ID}
          plugins={[BACKGROUND_COLOR_PLUGIN]}
          data={dataSet}
          height={50}
          options={options}
        ></Line>
      ) : (
        <div>Cargando...</div>
      )}
    </>
  );
};

export default DerivacionesOrionTiempo;
